import { sfCalendarInlineSvgIconDirective } from './calendar-inline-svg-icon/calendar-inline-svg-icon.directive';

export const DirectivesModule = angular
  .module('sfMobile.directives', [])
  .directive('sfCalendarInlineSvgIcon', sfCalendarInlineSvgIconDirective).name;
